/** returns the current device where our app is running
@return { String } - desktop, ios or android
*/
export const getDeviceInUse = state => state.deviceInUse

/** returns if our app is running as an apk app
@return { Boolean }
*/
export const getMobileAppState = state => state.mobileApp

/** returns if our app needs to show alert remember me modal
@return { Boolean }
*/
export const getShowAlertRememberMeModalState = state => state.showAlertRememberMeModal

/** returns if our app is running as an apk app
@return { Boolean }
*/
export const getStatusBarStyle = state => state.statusBarStyle

/** returns if app theme mode selected
@return { String } ['particular-light', 'particular-dark', 'company-light', 'company-dark']
*/
export const getAppTheme = state => `${state.appThemeClientType}-${state.themeMode}`

/** returns what client type is selected
@return { String } ['particular', 'company']
*/
export const getClientType = state => state.appThemeClientType

/** returns if app theme mode selected
@return { String }
*/
export const getAppThemeModeId = state => state.themeModeId

/** returns if app theme mode selected
@return { String }
*/
export const getAppThemeMode = state => state.themeMode

/** returns if our feature can emit back, or if should be prevented
@return { Boolean }
*/
export const getPreventMobileFeatureBackState = state => state.preventMobileFeatureBack

/** returns if our side;odal can emit back, or if should be prevented
@return { Boolean }
*/
export const getPreventMobileSideModalBackState = state => state.preventMobileSideModalBack

/** returns the current app view scroll position
@return { Number }
*/
export const getAppScroll = state => state.appScroll

/** returns the current side Modal scroll position
@return { Number }
*/
export const getSideModalScroll = state => state.sideModalScroll

/** returns if footer is being showed or not
@return { Boolean }
*/
export const getFooterState = state => state.footerIsBeingShowed

/** returns keyboard height, this is used for mobile
@return { String }
*/
export const getKeyboardHeight = state => state.keyboardHeight

/** returns if App is transparent or not
@return { Boolean }
*/
export const getApplyTransparencyToApp = state => state.applyTransparencyToApp

/** returns route params saved, so view receive it as props
@return { Object }
*/
export const getRouteParams = state => {
    return state.routeParams
}

/**************************************************
*												  *
*	               TOKEN Modal Logic           	  *
*												  *
**************************************************/
/** returns the state of token modal, if is being displayed or not
@return { Boolean }
*/
export const getShowTokenModalDisplayState = state => {
    return state.showTokenChallengeModal
}

/** returns challenge mock for token submit response
@return { Object }
*/
export const getTokenModalInfo = state => {
    return state.tokenChallengeData
}
